import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import FidgetLoader from './FidgetLoader';
import './ProtectedRoute.css';

function ProtectedRoute({ element }) {
    const { isAuthenticated, isLoading, user } = useAuth0();

    // check that the user has the 'access_granted' role from auth0
    const rolesClaim = process.env.REACT_APP_AUTH0_ROLES_CLAIM;
    const hasAccessGrantedRole = user?.[rolesClaim]?.includes('access_granted');
    const schoolVerified = sessionStorage.getItem('schoolPasswordVerified') === 'true';

    if (isLoading) {
        return (
            <div className="fidget__container">
                <FidgetLoader />
            </div>
        );
    }

    return (isAuthenticated && hasAccessGrantedRole) || schoolVerified ? (
        element
    ) : (
        <Navigate to="/verify-access-code" />
    );
}

export default ProtectedRoute;
